import React from "react";
import { connect } from "react-redux";
import "../../../../css/soldout.css";
import { Translation } from "react-i18next";
import { myFav } from "../../../../models";

export class Soldout extends React.Component {
  handleAddWishList = () => {
    const { product, wishListData } = this.props;
    const found = wishListData.wishListItems.findIndex(
      data => data.channelCatalogItemCode === product.code
    );
    if (found !== -1) {
      // 已在願望清單，移除自己
      this.props.removeFromMyFav(product.code);
    } else {
      // 不在願望清單，加入自己
      const data = {
        channelCatalogItemCode: product.code
      };
      this.props.addToMyFav(data);
    }
  };

  isWishList = () => {
    const { product, wishListData } = this.props;
    if (wishListData && product) {
      const { code } = product;
      const found = wishListData.wishListItems.findIndex(
        data => data.channelCatalogItemCode === code
      );
      if (found !== -1) {
        return "active";
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  render() {
    return (
      <div className="soldout-content">
        <button className="soldout-btn">
          <Translation>{t => <>{t("rightIndex.soldOut")}</>}</Translation>
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    showSoldOut: state.order.soldout,
    product: state.product.product,
    wishListData: state.myFav.wishListItems,
    getWishListSuccessfully: state.myFav.getWishListSuccessfully
  };
};

const mapDispatchToProps = () => {
  return {
    addToMyFav: wishItemCode => myFav.actions.addToMyFav(wishItemCode),
    removeFromMyFav: wishItemCode => myFav.actions.removeFromMyFav(wishItemCode)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Soldout);
